import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { ModalType } from 'constants/modal';
import { useInAppState } from 'contexts/InAppProvider';
import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { useClient } from 'ui-hooks/useClient';
import { useMedia } from 'ui-hooks/useMediaQuery';
import { LocalStorage } from 'utils/LocalStorage';
import { ModalHandler } from 'utils/ModalHandler';

export const useShowAppPushOnBottomModal = (title: string) => {
  const { isApp, isWeb } = useClient();
  const { isPc } = useMedia();
  const { isPushOn } = useInAppState();

  const markAppPushOnHideTime = useCallback(() => {
    LocalStorage.setItem(LocalStorageKey.AppPushOnBottomModalHideTime, DateTime.now().toJSDate().getTime().toString());
  }, []);

  const markAppInstallHideTime = useCallback(() => {
    LocalStorage.setItem(
      LocalStorageKey.AppInstallForPushBottomModalHideTime,
      DateTime.now().toJSDate().getTime().toString(),
    );
  }, []);

  const showAppPushBottomModal = useCallback(() => {
    if (LocalStorage.getItem(LocalStorageKey.AppPushOnBottomModalHideTime)) {
      return;
    }

    ModalHandler.show(ModalType.AppPushOn, {
      title,
      description: '푸시로도 알림을 받으려면, 기기 알림 설정을 켜주세요.',
      onClickPushOn: markAppPushOnHideTime,
      onCancel: markAppPushOnHideTime,
    });
  }, [markAppPushOnHideTime, title]);

  const showAppInstallBottomModal = useCallback(() => {
    if (LocalStorage.getItem(LocalStorageKey.AppInstallForPushBottomModalHideTime)) {
      return;
    }

    ModalHandler.show(ModalType.AppInstall, {
      title,
      description: '푸시로도 알림을 받으려면, 디리토 앱을 다운로드해보세요.',
      onClickDownload: markAppInstallHideTime,
      onCancel: markAppInstallHideTime,
    });
  }, [markAppInstallHideTime, title]);

  const showBottomModal = useCallback(() => {
    if (isApp && !isPushOn) {
      showAppPushBottomModal();
      return;
    }

    if (isWeb && !isPc) {
      showAppInstallBottomModal();
    }
  }, [isApp, isPc, isPushOn, isWeb, showAppInstallBottomModal, showAppPushBottomModal]);

  return showBottomModal;
};
